window.SmartLightingControl = {
  activateColorVariant(titleHandle, titleName, sku) {
    const activeColorNameSelector =
      '[data-smart-lighting-control-dimmer-switch-content-color-name]';
    const activeSwatchSelector =
      '[data-smart-lighting-control-dimmer-switch-content-swatch][data-active=true]';
    const activeImageSelector =
      '[data-smart-lighting-control-dimmer-switch-content-image][data-active=true]';
    const selectedSwatchSelector = `[data-smart-lighting-control-dimmer-switch-content-swatch][data-color-swatch-option-value="${titleHandle}"]`;
    const selectedImageSelector = `[data-smart-lighting-control-dimmer-switch-content-image][data-sku='${sku}']`;

    updateColorName(activeColorNameSelector);
    toggleActiveAttribute(activeSwatchSelector);
    toggleActiveAttribute(activeImageSelector);
    toggleActiveAttribute(selectedSwatchSelector);
    toggleActiveAttribute(selectedImageSelector);

    function toggleActiveAttribute(selector) {
      document.querySelectorAll(selector).forEach((el) => {
        el.setAttribute(
          'data-active',
          String(el.getAttribute('data-active') !== 'true')
        );
      });
    }

    function updateColorName(selector) {
      const colorLabelElement = document.querySelector(selector);

      if (colorLabelElement) {
        colorLabelElement.innerHTML = titleName;
      }
    }
  },
};
